import { render } from "./StrategicNavigation.vue?vue&type=template&id=4cba26fa&scoped=true"
const script = {}

import "./StrategicNavigation.vue?vue&type=style&index=0&id=4cba26fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cba26fa"]])

export default __exports__